

import React, { useEffect, useState } from "react";
import Services from "../../../services/services";
import { useSelector } from "react-redux";

const CloneManager = () => {
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [amount, setAmount] = useState(null);
    const authStore = useSelector((state) => state.auth);
    const username = authStore.user?.username ?? "";
    const password = authStore.user?.password ?? "";

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const res = await Services.CloneManager.getProducts(username, password);
                const data = await res.json()
                setProducts(data.products ?? []);
            } catch (error) {
                console.error("Failed to fetch products:", error);
            }
        }
        fetchProducts();
    }, [username, password]);

    return (<>
        <div className="flex flex-col gap-2">
            {selectedProduct && (
                <div className="flex flex-col gap-2">
                    <div className="flex border gap-2 p-2 rounded-lg bg-gray-100">
                        <span className="font-bold">#{selectedProduct.id}</span>
                        <span className="text-green-700 font-bold">Còn {selectedProduct.amount.toLocaleString()}</span>
                        <span className="text-yellow-700 font-bold">Giá: {parseInt(selectedProduct.price).toLocaleString()}đ</span>
                        <span>{selectedProduct.name}</span>
                    </div>
                    <input classname="" width={50} height={20} value={amount} onChange={(e) => setAmount(e.target.value)} type="number" placeholder="Số lượnaag" className="input input-bordered w-full max-w-xs" />
                    <span>Tổng tiền: {(amount * parseInt(selectedProduct.price)).toLocaleString()}đ</span>
                    <button classname="border rounded-lg bg-green-500 hover:bg-green-600 px-3 py-2">
                        Nạp nguyên liệu
                    </button>
                </div>
            )}
            <h3 className="font-bold text-lg">Danh sách sản phẩm</h3>
            {products.map((product) => {
                if (product.amount <= 0) return null;
                var price = parseInt(product.price);
                return (
                    <div className="flex border gap-2 p-2 rounded-lg bg-gray-100 hover:bg-gray-200 cursor-pointer"
                        onClick={() => setSelectedProduct(product)}>
                        <span className="font-bold">#{product.id}</span>
                        <span className="text-green-700 font-bold">Còn {product.amount.toLocaleString()}</span>
                        <span className="text-yellow-700 font-bold">Giá: {price.toLocaleString()}đ</span>
                        <span>{product.name}</span>
                    </div>
                )
            }).filter((item) => item !== null)}
        </div>
    </>);
}

export default CloneManager;